<template>
  <div class="about-sns-buttons">
    <div class="about-sns-buttons__icons">
      <a href="https://x.com/_giftee">
        <ImgLazy
          :image-url="XImage"
          alt-text="x"
          aspect-ratio="1"
          class="about-sns-buttons__icon"
        />
      </a>
      <a href="https://www.facebook.com/giftee.co/">
        <ImgLazy
          :image-url="FacebookImage"
          alt-text="facebook"
          aspect-ratio="1"
          class="about-sns-buttons__icon"
        />
      </a>
      <a href="https://www.instagram.com/_giftee">
        <ImgLazy
          :image-url="InstagramImage"
          alt-text="instagram"
          aspect-ratio="1"
          class="about-sns-buttons__icon"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
import FacebookImage from '../../../../../../images/abouts/sns/facebook.svg'
import XImage from '../../../../../../images/abouts/sns/x.svg'
import InstagramImage from '../../../../../../images/abouts/sns/glyph-logo_May2016.png'
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
</script>

<style lang="scss" scoped>
.about-sns-buttons {
  background-color: $gray-3;

  &__icons {
    margin: auto;
    display: flex;
    justify-content: space-between;
    width: 208px;

    @media all and (max-width: ($pc-width  - 1)) {
      width: 152px;
    }
  }

  &__icon {
    @extend %hover-common;
    width: 32px;
    height: 32px;

    @media all and (max-width: ($pc-width  - 1)) {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
